<template>
    <ui5-date-picker
        style="
            transform: scaleX(0.98) scaleY(0.98);
            margin-top: -1.5px;
            margin-right: 11px;
            margin-left: -2px;
        "
        v-bind="$attrs"
        v-on="$listeners"
        ref="datepicker"
    />
</template>

<script>
export default {
    name: 'Ui5DatePickerStyled',
    inheritAttrs: false,

    mounted() {
        this.styleDatePicker();
    },

    updated() {
        this.styleDatePicker();
    },

    methods: {
        styleDatePicker() {
            const datePicker = this.$refs.datepicker;

            const input = datePicker.shadowRoot.querySelector('ui5-input');
            if (input) {
                input.style.borderRadius = '8px';

                const inputContentStyle =
                    input.shadowRoot.querySelector('.ui5-input-content').style;
                inputContentStyle.transform = 'scaleY(1.1) scaleX(1.08)';
                inputContentStyle.color = '#545454c7';
                inputContentStyle.paddingLeft = '5px';
                inputContentStyle.paddingRight = '5px';
            }

            console.log(
                'Ui5DatePickerStyled rendered. Current value:',
                datePicker.value
            );
        },
    },
};
</script>
